import {
	MotifModal,
	MotifModalHeader,
	MotifModalBody,
	MotifModalFooter,
	MotifButton,
} from "@ey-xd/motif-react";
import "./CancelModal.scss";

interface CancelModalProps {
	show: boolean;
	setShow: (isVisible: boolean) => void;
	cancelHandler: () => void;
	isCancelLoading: boolean;
}

const CancelModal = ({
	show,
	setShow,
	cancelHandler,
	isCancelLoading,
}: CancelModalProps) => {
	return (
		<MotifModal
			show={show}
			className="cancel-order-modal"
			size="default"
			focusTrapOptions={{
				tabbableOptions: {
					displayCheck: "none",
				},
			}}
		>
			<MotifModalHeader>Alert: Cancellation</MotifModalHeader>
			<MotifModalBody>
				<div className="cancel-modal-content">
					<p>
						Are you sure you want to cancel this SKU order? This action cannot
						be undone. Please confirm your choice.
					</p>
				</div>
			</MotifModalBody>
			<MotifModalFooter>
				<MotifButton
					onClick={() => {
						setShow(false);
					}}
					variant="secondary"
				>
					Keep Order
				</MotifButton>
				<MotifButton
					loading={isCancelLoading}
					disabled={isCancelLoading}
					onClick={cancelHandler}
				>
					Cancel Order
				</MotifButton>
			</MotifModalFooter>
		</MotifModal>
	);
};
export default CancelModal;
